import { render, staticRenderFns } from "./BridgeSelect.vue?vue&type=template&id=2bc4450b&scoped=true&"
import script from "./BridgeSelect.vue?vue&type=script&lang=js&"
export * from "./BridgeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4450b",
  null
  
)

export default component.exports